// Site wide functions here
import domready from 'domready';
import tippy from './tippy';
import showSiteNav from './site-navigation';

const toolTipSelector = '.has-tooltip, .ifi-sign-question';
const twofactorSelector = '.twofactor-password';
const twofactorInputSelector = '.twofactor-password__input';
const twofactorHiddenSelector = '#pin';

function init(args) {
    const { login } = args;
    domready(() => {
        const { siteNav } = login;

        // Show left aside
        if (siteNav) {
            showSiteNav(siteNav);
        }

        // Prepare tooltips
        tippy(toolTipSelector, {
            allowHTML: true,
            arrow: true,
            theme: 'light-border'
        });

        initOtpInputs();
    });
}

function initOtpInputs() {
    const twofactorContainer = document.querySelector(twofactorSelector);
    if (!twofactorContainer) {
        return;
    }
    const twofactorInputs = [...twofactorContainer.querySelectorAll(twofactorInputSelector)];
    const hiddenPinInput = document.querySelector(twofactorHiddenSelector);
    const focusFirstInput = () => {
        if (!twofactorInputs.length) return;
        const active = document.activeElement;
        if (!active || active === document.body) {
            twofactorInputs[0].focus();
        }
    };
    // Update hidden pin value from visible inputs
    const updateHiddenPin = () => {
        if (!hiddenPinInput) return;
        hiddenPinInput.value = twofactorInputs.map(input => input.value).join('');
    };

    // Handle typing into inputs
    twofactorContainer.addEventListener('input', (event) => {
        const currentInput = event.target;
        const currentIndex = twofactorInputs.indexOf(currentInput);
        if (currentIndex === -1) return;

        // Allow only one digit per input
        currentInput.value = (currentInput.value.match(/\d/) || [''])[0];

        // Move focus to next input if digit entered
        if (currentInput.value && currentIndex < twofactorInputs.length - 1) {
            twofactorInputs[currentIndex + 1].focus();
        }

        updateHiddenPin();
    });

    // Handle backspace navigation
    twofactorContainer.addEventListener('keydown', (event) => {
        if (event.key !== 'Backspace') return;

        const currentInput = event.target;
        const currentIndex = twofactorInputs.indexOf(currentInput);
        if (currentIndex === -1) return;

        // If current input is empty, move focus back
        if (!currentInput.value && currentIndex > 0) {
            twofactorInputs[currentIndex - 1].focus();
        }
    });

    // Handle paste code
    twofactorContainer.addEventListener('paste', (event) => {
        const currentInput = event.target;
        const startIndex = twofactorInputs.indexOf(currentInput);
        if (startIndex === -1) return;

        const pastedDigits = (event.clipboardData?.getData('text') || '')
            .replace(/\D/g, '');

        if (!pastedDigits) return;

        event.preventDefault();

        pastedDigits
            .slice(0, twofactorInputs.length - startIndex)
            .split('')
            .forEach((digit, offset) => {
                twofactorInputs[startIndex + offset].value = digit;
            });

        const lastIndex = Math.min(
            startIndex + pastedDigits.length,
            twofactorInputs.length
        ) - 1;

        twofactorInputs[lastIndex].focus();
        updateHiddenPin();
    });

    updateHiddenPin();
    // Ensure first OTP input is focused on load for accessibility and tests
    focusFirstInput();
}

export default init;
